import api from 'services/api';

export async function getApplicationForm({
  id,
  organizationId,
}: {
  id: string;
  organizationId: string;
}) {
  return api.get(`api/dashboard/organizations/${organizationId}/application_forms/${id}`);
}
